module.exports = __webpack_public_path__ + "img/arrow_drop_down.110d4a47.svg";